import { Collapse, Select, Table } from 'antd';
import type { TableProps } from 'antd';
import { SelectProps } from 'antd/es/select';
import styled from 'styled-components';

export const Title = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding: 16px 24px 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.16px;
`;

export const StyledCollapse = styled(Collapse)`
  &.emp-ant-collapse .emp-ant-collapse-item {
    display: flex;
    flex-direction: column;
    gap: 8px;

    padding: 16px 24px 16px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0;

    .emp-ant-collapse-header {
      padding: 0;
      align-items: center;
    }

    .emp-ant-collapse-content .emp-ant-collapse-content-box {
      padding: 0;
      padding-block: 0;
    }
  }
`;

export const CollapseHeader = styled.div`
  color: rgba(0, 0, 0, 0.88);
  font-weight: 500;
  letter-spacing: -0.14px;
`;

export const EventJourneySelect = styled(Select)<SelectProps<any>>`
  &.emp-ant-select {
    .emp-ant-select-selector {
      color: #0046ff;
    }
  }
`;

export const FunnelTableWrapper = styled(Table)`
  overflow: auto;
  .emp-ant-table {
    .emp-ant-table-tbody {
      > tr {
        > td {
          padding: 8px 16px !important;
          // hack to give child divs height 100%
          height: 1px;
          vertical-align: top;
        }
      }
      .checkbox-wrapper {
        margin: -8px -16px;
        height: calc(100% + 16px);
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .emp-ant-table-thead {
      > tr:first-child {
        > th {
          border-top: 1px solid #d9d9d9;
          padding: 8px;
          border-start-start-radius: 0 !important;
          border-start-end-radius: 0 !important;
          color: rgba(0, 0, 0, 0.88);
          min-height: 32px;
          border-bottom: 0;
          &::before {
            background-color: inherit !important;
          }
          .left-wrapper {
            margin: -8px;
            text-align: left;
            padding-left: 8px;
          }
        }
      }
      > tr:last-child {
        > th {
          border-bottom: 1px solid #d9d9d9;
          padding: 8px;
          border-start-start-radius: 0;
          color: rgba(0, 0, 0, 0.45);
          min-height: 32px;
          font-size: 12px;
          vertical-align: bottom;
          &::before {
            background-color: inherit !important;
          }
        }
        > td {
          border-bottom: 1px solid #d9d9d9;
          padding: 8px;
          border-start-start-radius: 0;
          font-size: 12px;
          &::before {
            background-color: inherit !important;
          }
        }
      }
    }
    .first-row {
      > td {
        border-bottom: 2px solid #d9d9d9;
      }
    }
    .checkbox-column {
      > td {
        padding: 0;
        > div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .left-border {
      border-left: 1px solid #d9d9d9;
    }
    .left-wrapper {
      margin: -8px -16px;
      padding: 8px 16px;
    }
    .align-right {
      text-align: right;
      padding-right: -16px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
    }
  }
`;
